import { AxiosInstance } from 'axios';

import {
  NodeClassesAPIApiFactory,
  NodePoolsAPIApiFactory,
  NodeOverlaysAPIApiFactory,
  NodesAPIApiFactory,
  FeaturesAPIApiFactory,
  RebalancingAPIApiFactory,
  ScheduledRebalancingAPIApiFactory,
  StatusAPIApiFactory,
} from '@cast/openapi-kent';

import { AXIOS_CONFIGURATION } from '../constants';

export const KentApiAdapter = (client: AxiosInstance) => {
  const nodeClassesApi = NodeClassesAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );
  const nodePoolsApi = NodePoolsAPIApiFactory(AXIOS_CONFIGURATION, '', client);
  const nodeOverlaysApi = NodeOverlaysAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const featuresApi = FeaturesAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  const rebalancingApi = RebalancingAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const scheduledRebalancingApi = ScheduledRebalancingAPIApiFactory(
    AXIOS_CONFIGURATION,
    '',
    client
  );

  const statusApi = StatusAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  const nodesApi = NodesAPIApiFactory(AXIOS_CONFIGURATION, '', client);

  return {
    getEc2NodeClasses: nodeClassesApi.nodeClassesAPIListEC2NodeClasses,
    getAksNodeClasses: nodeClassesApi.nodeClassesAPIListAKSNodeClasses,
    getNodePools: nodePoolsApi.nodePoolsAPIListNodePools,
    getNodeOverlays: nodeOverlaysApi.nodeOverlaysAPIListNodeOverlays,
    getNodeOverlay: nodeOverlaysApi.nodeOverlaysAPIGetNodeOverlay,

    updateNodePool: nodePoolsApi.nodePoolsAPIUpdateNodePool,
    updateEC2NodeClass: nodeClassesApi.nodeClassesAPIUpdateEC2NodeClass,
    updateAKSNodeClass: nodeClassesApi.nodeClassesAPIUpdateAKSNodeClass,

    getKentrollerStatusDetails: statusApi.statusAPIGetKentStatus,

    getClusterOverview: featuresApi.featuresAPIGetOverview,
    getClusterFeatures: featuresApi.featuresAPIListFeatures,
    getClusterFeature: featuresApi.featuresAPIGetFeature,
    getClusterFeaturesCompatibility:
      featuresApi.featuresAPIListFeatureCompatibilities,
    configureClusterFeature: featuresApi.featuresAPIConfigureFeature,
    getClusterInstallScript: featuresApi.featuresAPIGetClusterInstallScript,
    getOrganizationInstallScript:
      featuresApi.featuresAPIGetOrganizationInstallScript,

    listRebalancingPlans: rebalancingApi.rebalancingAPIListRebalancingPlans,
    getRebalancingPlan: rebalancingApi.rebalancingAPIGetRebalancingPlan,
    executeRebalancingPlan: rebalancingApi.rebalancingAPIExecuteRebalancingPlan,
    generateRebalancingPlan: rebalancingApi.rebalancingAPICreateRebalancingPlan,
    getWorkloads: rebalancingApi.rebalancingAPIListWorkloads,
    getFeaturesConfigs: featuresApi.featuresAPIListFeatureConfigs,
    getRebalancingConstraints:
      rebalancingApi.rebalancingAPIGetRebalancingConstraints,

    listRebalancingSchedules:
      scheduledRebalancingApi.scheduledRebalancingAPIListRebalancingSchedules,
    createRebalancingSchedule:
      scheduledRebalancingApi.scheduledRebalancingAPICreateRebalancingSchedule,
    updateRebalancingSchedule:
      scheduledRebalancingApi.scheduledRebalancingAPIUpdateRebalancingSchedule,
    deleteRebalancingSchedule:
      scheduledRebalancingApi.scheduledRebalancingAPIDeleteRebalancingSchedule,
    deleteNode: nodesApi.nodesAPIDeleteNode,
    drainNode: nodesApi.nodesAPIDrainNode,
    interruptNode: nodesApi.nodesAPIInterruptNode,
  };
};
